// @flow
import { connect } from 'react-redux';
import PlanFrame from './PlanFrame';
import {
  currentSubscriptionSelector,
  isCurrentSubscriptionSuspendedSelector,
  isLineOFFSelector,
  touchPlanFrame,
} from '../../../modules/Dashboard';
import { isLoadingSelector } from '../../../modules/LoadingStatus';

const mapStateToProps = state => ({
  subscription: currentSubscriptionSelector(state),
  isFetching: isLoadingSelector(state, 'fetchAllSubscriptions'),
  isLoadingForToggling: isLoadingSelector(state, 'loadingPlanForTurnBackOn'),
  isLineOFF: isLineOFFSelector(state),
  isSubscriptionSuspended: isCurrentSubscriptionSuspendedSelector(state),
});

const mapDispatchToProps = {
  toggleFolded: touchPlanFrame,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanFrame);
